<template>
	<div class="vue-form">
    <b-jumbotron>
    <p v-html="intro.subtitle" class="lead" style="margin: 0 0 .5em 0; font-size: 1.9em; font-weight: 600;"></p>
    <p v-html="intro.desc" class="lead" style="font-size: 1.1em;"></p>
  </b-jumbotron>

		<form
			ref="form"
			:action="results.action"
			method="post"
			@submit="onSubmit"
			name="vfm"
		>
			<input type="hidden" name="post" :value="results.post" />

			<div class="email_field_group">
				<input
					type="hidden"
					:name="'email_1_from_name'"
					:value="results.emails[0].from_name"
				/>
				<input
					type="hidden"
					:name="'email_1_from'"
					:value="results.emails[0].from"
				/>
				<input
					type="hidden"
					:name="'email_1_to'"
					:value="results.emails[0].to"
				/>
				<input
					type="hidden"
					:name="'email_1_subject'"
					:value="results.emails[0].subject"
				/>
				<input type="hidden" :name="'email_1_body'" :value="email_1_body" />
			</div>

			<div class="email_field_group">
				<input
					type="hidden"
					:name="'email_2_from_name'"
					:value="results.emails[1].from_name"
				/>
				<input
					type="hidden"
					:name="'email_2_from'"
					:value="results.emails[1].from"
				/>
				<input
					type="hidden"
					:name="'email_2_to'"
					:value="items.vfm_email.data"
				/>
				<input
					type="hidden"
					:name="'email_2_subject'"
					:value="results.emails[1].subject"
				/>
				<input type="hidden" :name="'email_2_body'" :value="email_2_body" />
			</div>

			<div class="csv_field_group" v-for="(csv, f_index) in this.csv_files">
				<input
					type="hidden"
					:name="'csv_' + (f_index + 1).toString() + '_file'"
					:value="'/upload/results/' + csv.path + csv.file"
				/>
				<input
					v-for="(item, key, i_index) in items"
					:key="key"
					:name="csvEnum(item.name, f_index, i_index)"
					type="hidden"
					:value="getCSVValue(csv.omit, key)"
				/>
				<input name="csv_1_field_16" type="hidden" value="Stamp" />
			</div>
			
			<input type="hidden" name="Stamp" :value="results.stamp" />
			<input type="hidden" name="confirm" :value="results.confirm" />
			<input type="hidden" name="confirm_template" :value="confirm_template" />
			<div class="miners">
			  <label>hidden
				<input class="miners" name="miners" value />
			  </label>
			</div>

			<!-- <b-modal v-model="meta.closed"></b-modal> -->

			<div class="vfm_item" v-for="(item, key) in items">
        <div v-if="item.section_header">
          <p style="color: #071d49; font-size: 1.2em;">{{ item.section_header }}</p>
        </div>
				<span v-if="item.type === 'nodata'">
					<b-card
						v-if="item.style && item.style === 'card'"
						border-variant="secondary"
						bg-variant="light"
						:header="item.title"
						header-text-variant="white"
						header-bg-variant="secondary"
					>
						<p class="card-text">{{ item.label }}</p>
					</b-card>
					<div v-else-if="item.style && item.style === 'html'">
						<span v-html="item.label" style="font-size: .8rem"></span>
					</div>
					<h4 v-else>
						<hr v-if="!item.first" />
						<span v-html="item.label"></span>
					</h4>
				</span>
				<b-form-group
					v-else-if="item.type === 'radio'"
					v-show="item.show"
					:label-for="item.name"
					:description="item.help"
					style="margin-left: 25px"
				>
					<label>{{ item.label }}
					<b-form-radio-group
						stacked
						v-model="item.data"
						v-on:input="radioTrig(key, item.ctrl, item.data)"
						:name="item.name"
						:options="item.init.options"
					></b-form-radio-group>

					<input
						hidden
						type="radio"
						:name="item.name"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					/>
					</label>

					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'select'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-select
						v-model="item.data"
						:id="item.name"
						:name="item.name"
						:options="vfm_init(key)"
						v-validate="item.reqs"
						data-vv-validate-on="change"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-select>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'checkbox'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-checkbox-group
						v-model="item.data"
						:id="item.id"
						size="sm"
						:name="item.name"
						:options="item.init.options"
						v-validate="item.reqs"
					></b-form-checkbox-group>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'textarea'"
					v-show="item.show"
					:label-for="item.name"
					:description="item.help"
					style="margin-left: 25px"
				>
					<label>{{ item.label }}
					<b-form-textarea
						v-model="item.data"
						:name="item.name"
						:placeholder="item.init.placeholder"
						:rows="5"
						:max-rows="10"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-textarea>
					<span v-if="item.reveal">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.reveal && !items[item.reveal.target].show"
							v-on:click="clickReveal(item)"
							>{{ item.reveal.text }}</b-btn
						>
					</span>
					<span v-if="item.hide && item.reveal">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.hide && !items[item.reveal.target].show"
							v-on:click="clickHide(item)"
							>{{ item.hide.text }}</b-btn
						>
					</span>
					<span v-if="item.hide && typeof item.reveal === 'undefined'">
						<b-btn
							variant="link"
							size="sm"
							v-show="item.hide"
							v-on:click="clickHide(item)"
							>{{ item.hide.text }}</b-btn
						>
					</span>
					</label>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else-if="item.type === 'link'"
					v-show="item.show"
					:description="item.help"
				>
					<span v-html="item.label"></span>
				</b-form-group>

				<b-form-group
					v-else-if="item.name.includes('Phone')"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-form-input
						:type="item.type"
						:name="item.name"
						:id="item.name"
						v-model="item.data"
						v-bind:formatter="phoneFormatter"
						maxlength="10"
						:placeholder="vfm_init(key)"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-input>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

				<b-form-group
					v-else
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
					style="margin-left: 25px"
				>
					<b-form-input
						:type="item.type"
						:name="item.name"
						:id="item.name"
						v-model="item.data"
						:placeholder="vfm_init(key)"
						v-validate="item.reqs"
						:class="{ 'is-danger': errors.has(item.name) }"
					></b-form-input>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>
			</div>
			<b-card bg-variant="light" text-variant="dark" style="font-size: .8em">
						<p style="font-size: 1.2; font-weight: bold;">Notes:</p>
						<p>Even if a specific advisor is selected, the department reserves the right to assign a different advisor.</p>
						<p>To change from a special (not degree seeking) student to a degree seeking status requires a completed admissions application.</p>
						<p style="font-weight: bold;">*Double Major:</p>
						<ul>
							<li>An undergraduate student who wishes to qualify for a double major in two science programs must complete all requirements for both degrees as they are laid out in the catalog.</li>
							<li>This means earning a minimum of 120 credits for science majors or 130 credits for engineering majors plus all additional unique credits for the second major.</li>
							<li>The degrees must be earned concurrently, meaning you should not apply for graduation until you have finished both degrees.</li>
							<li>The System General Education requirements must be met once.</li>
							<li>A student will receive a single diploma with both majors printed under a single Bachelor of Science degree.</li>
							<li>Can pursue more than two majors. All above rules will apply to every major.</li>
						</ul>
						<p style="font-weight: bold;">*Second Degree:</p>
						<ul>
							<li>A student completes all courses and credits for each degree, as they are laid out in the catalog</li>
							<li>A minimum of 30 unique credits of the second degree must not be applicable to the first degree, meaning you will complete a minimum of 150 to 160 credits depending on the two degrees chosen</li>
							<li>The degrees can be earned consecutively (in different semesters) or concurrently (in the same semester)</li>
							<li>Two separate diplomas are printed, one for each degree</li>
							<li>The residency requirement of a minimum of 30 credit hours completed at the institution granting the degree applies to both degree programs</li>
							<li>Can pursue more than two degrees. If pursuing more than two degrees, all above rules apply, and each additional degree will require completing 30 additional unique credits</li>
						</ul>
						<p>A Double Major or Second Degree can have potential financial aid implications. Please contact the Financial Aid office before declaring a double major or second degree: 605-394-2274</p>
			</b-card>
			
			<!--<hr />-->

			<b-card
				show
				bg-variant="light"
				id="terms-gp"
				name="terms-gp"
				v-if="terms.show"
			>
				<h6 v-if="terms.title">{{ terms.title }}</h6>
				<p class="help-text" v-if="terms.text">{{ terms.text }}</p>
				<hr v-if="terms.text" />
				<b-form-checkbox
					id="terms-cb"
					name="terms-cb"
					v-model="terms.data"
					value="accepted"
					unchecked-value
					v-validate.initial="'required'"
					><p v-html="terms.label"></p>
				</b-form-checkbox>
			</b-card>
			<!--<hr />-->
			<b-button :disabled="errors.any()" size="lg" type="submit" variant="dark" style="margin-top: 1em"
				>Submit</b-button
			>
			<!-- <b-button :disabled='true' size='lg' type='submit' variant='dark'>Submit</b-button> -->
			<p v-show="errors.any()" style="font-size:.8rem; color: #999999; line-height: 3em">Button disabled. Some required fields are missing.</p> 
		</form>

		<div id="debug" class="debug" v-show="meta.datadebug">
			<h2>Debug</h2>
			<div>
				Errors = {{ errors.any() }}
				<br />
				{{ errors.all() }}
			</div>
			<ul v-for="item in items">
				<span v-if="item.type !== 'nodata'">
					<li>
						<div>
							{{ item.name }}:
							<span class="data-debug">{{ item.data }}</span>
						</div>
						<div v-if="item.ctrl">{{ item.ctrl }}</div>
					</li>
				</span>
			</ul>
			<div v-for="csv in csvPath_a">{{ csv.path }}</div>
			<div>{{ results.confirm }}</div>
		</div>
		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Confirm Template:</h3>
			<hr style="border-bottom: dashed 1px" />
		</div>
		<div id="confirm_template" v-show="meta.templatedebug">
			<b-row>
				<b-col>
					<p><b>Thank you </b></p>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<h5>Submission Details:</h5>
				</b-col>
			</b-row>
			<span v-for="item in items" :key="item.name">
			<b-row v-if="item.style != 'html' && item.show">
				<b-col cols="6">
					<strong v-if="item.type=='nodata'">{{ item.confirmLabel }}</strong>
				</b-col>
				<b-col cols="6">{{ item.data }}</b-col>
			</b-row>
			</span>
		</div>

		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Email Template 1:</h3>
			<h6>To: {{ results.emails[0].to }}</h6>
			<hr style="border-bottom: dashed 1px" />
		</div>
		<div id="email_template_1" v-show="meta.templatedebug">
			<div style>
				<table
					border="0"
					style="border-collapse: collapse; font: Arial normal 10pt ;"
					cellpadding="3"
				>
					<tr>
						<td colspan="4">
							<p>
								This is an automated message to let you know that you have a new
								submission for the 
								<em>{{ intro.subtitle }}</em> located at
								<a
									:href="
										'https://interact.sdsmt.edu/' +
											meta.root +
											'/' +
											meta.sub +
											'/'
									"
									>https://interact.sdsmt.edu/{{ meta.root }}/{{ meta.sub }}/</a
								>.
							</p>

<!--							<p>
								The link to the submission results file for this form is
								<a
									:href="
										'https://sdmines.sdsmt.edu/upload/results/' +
											results.csv_files[0].path +
											results.csv_files[0].file
									"
								>
									https://sdmines.sdsmt.edu/upload/results/{{
										results.csv_files[0].path
									}}{{ results.csv_files[0].file }} </a
								>.</p>
								<p><strong>Remember</strong>, this file may contain personally identifiable
								information from previous submissions, so <strong>please do not share
								this link.</strong>
							</p>

							<p>
								If you have any trouble accessing the data you've received from
								this submission, please contact
								<a href="mailto:vickie.bender@sdsmt.edu">ITS</a>.
							</p>
-->							
						</td>
					</tr>
				</table>

				<hr />
				<h4>Submission Information</h4>
				<hr />
				<table
					border="0"
					style="width:100%; border-collapse:collapse;"
					cellpadding="3"
				>
					<div v-for="item in items" :key="item.name">
						<tr v-if="item.style != 'html' && item.show">
							<td style="vertical-align:top; width: 25%">
								<b>{{ item.confirmLabel }}: </b>
							</td>
							<td style="vertical-align:top">{{ item.data }}</td>
						</tr>
					</div>
				</table>
			</div>
		</div>

		<div v-if="meta.templatedebug">
			<h3 style="margin-top: 2em">Email Template 2:</h3>
			<h6>To: {{ results.emails[1].to }}</h6>
			<hr style="border-bottom: dashed 1px" />
		</div>
		
		<div id="email_template_2" v-show="meta.templatedebug">
			<div style>
				<table
					border="0"
					style="border-collapse: collapse; font: Arial normal 10pt ;"
					cellpadding="3"
				>
					<tr>
						<td colspan="4">
							<p><b>Thank you,</b> your request for the {{ intro.subtitle }} has been received. 
							Please review the information that you have submitted and contact <a href="mailto:registrar@sdsmt.edu">registrar@sdsmt.edu</a> if the information is incorrect or you would like to cancel your request.</p>
						</td>
					</tr>
				</table>
				
				<h4>Submission Information</h4>

				<table
					border="0"
					style="width:100%; border-collapse:collapse;"
					cellpadding="3"
				>
					<div v-for="item in items" :key="item.name">
						<tr v-if="item.style != 'html' && item.show">
							<td style="vertical-align:top; width: 25%">
								<b>{{ item.confirmLabel }}: </b>
								<!-- <span v-else>{{ item.label }}</span> -->
							</td>
							<td style="vertical-align:top">{{ item.data }}</td>
						</tr>
					</div>
					<div>
					</div>
					<tr>
						<td colspan="4">
							<p>
								<em>This is an automated response.</em>
							</p>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import {  dates, meta, intro, results, path_hash, terms, items } from "vfm/form-specs";

var timestamp = require("time-stamp");

export default {
	name: "VueForm",
	computed: {
		csvPath_a: function() {
			var a = [];
			for (var i = 0; i < this.results.csv_files.length; i++) {
				a[i] = {
					path: this.csvPath(i),
					omit: this.results.csv_files[i].omit
				};
			}
			return a;
		},
		
		dateError: function() {
			let startIndex = this.items.vfm_startdate.data ? this.dates.indexOf(this.items.vfm_startdate.data) : 0;
			let endIndex =   this.items.vfm_enddate.data ? this.dates.indexOf(this.items.vfm_enddate.data) : 0;
			if (endIndex > 0) return (endIndex - startIndex) > 0 ? false : true
			else return false
		},
			
		vfm_combined_name: function() {
			var s = "";
			for (var i = 0; i < this.hiddens.email_from_name.length; i++) {
				if (i !== 0) {
					s += " ";
				}
				if (
					typeof this.items[this.hiddens.email_from_name[i]] !== "undefined"
				) {
					s += this.items[this.hiddens.email_from_name[i]];
				} else s += this.hiddens.email_from_name[i];
			}
			return s;
		}
	},

	data() {
		return {
			meta: meta,
			results: results,
			items: items,
			intro: intro,
			path_hash: path_hash,
			terms: terms,
			email_1_body: "",
			email_2_body: "",
			confirm_template: "",
			csv_files: results.csv_files
		};
	},

	methods: {
		stampNow() {
			return timestamp("YYYY/MM/DD-HH:mm:ss");
		},

		onSubmit(evt) {
			evt.preventDefault();
			this.email_1_body = document.getElementById("email_template_1").innerHTML;
			this.email_2_body = document.getElementById("email_template_2").innerHTML;
			this.confirm_template = document.getElementById(
				"confirm_template"
			).innerHTML;
			results.stamp = this.stampNow();
			this.$validator.validateAll().then(result => {
				if (result) {
					if (this.results.miners !== "") {
						results.action = "https://interact.sdsmt.edu/not-authorized.asp";
					} else {
						// update
						results.action =
							"https://sdmines.sdsmt.edu/cgi-bin/global/send_message_2.cgi";
					}
					this.$nextTick(() => {
						this.$refs.form.submit();
					});
				} else {
					alert("Oops. Please fill in the required fields.");
				}
			});
		},

		getCSVValue(omit, key) {
			if (omit.indexOf(key) === -1) {
				return items[key].name;
			} else return " - ";
		},

		vfm_init(key) {
			var item = items[key];
			switch (item.type) {
				case "select":
					if (item.data === "") {
						item.data = null;
					}
					var ph = item.init.placeholder
						? item.init.placeholder
						: "Choose an option";
					var top = [
						{
							text: ph,
							value: null
						}
					];

					if (typeof item.ctrl !== "undefined") {
						if (typeof item.ctrl.from !== "undefined") {
							var key = items[item.ctrl.from];
							var opts = item.init.options[key.data];
							if (typeof opts !== "undefined") {
								if (opts.indexOf(item.data) === -1) {
									item.data = null;
								}
								var opts_oa = [];
								for (var i = 0; i < opts.length; i++) {
									opts_oa[i] = {
										text: opts[i],
										value: opts[i]
									};
								}
								return top.concat(opts_oa);
							}

							top[0].text = item.ctrl.msg
								? item.ctrl.msg
								: "Options depend on another field...";
							return top;
						}
					}
					return top.concat(item.init.options);
				default:
					return item.init.placeholder
						? item.init.placeholder
						: ["Enter response here."];
			}
		},

		csvEnum(name, f_index, i_index) {
			return (
				"csv_" + (f_index + 1).toString() + "_field_" + (i_index + 1).toString()
			);
		},

		stampEnum(f_index) {
			var max = Object.keys(items).length;
			return (
				"csv_" + (f_index + 1).toString() + "_field_" + (max + 1).toString()
			);
		},

		csvPath(f_index) {
			var s = "/upload/results/";
			var ref = this.results.csv_files[f_index].file;
			var path = s + this.results.csv_files[f_index].path;
			// if there's a field with the same name as ref, use its data to build the filename
			if (typeof this.items[ref] !== "undefined") {
				var key = this.items[ref].data;
				if (key !== null && key !== "") {
					var code = this.path_hash[key];
					if (typeof code !== "undefined") {
						return path + key + "-" + code + ".csv";
					} else console.log("Code not found for hashed value.");
				}
				return path + key + ".csv";
			}
			//else csv_filed[i].file is just a filename string
			return path + ref;
		},

		radioTrig(key, ctrl, data) {
			var r = "";
			if (typeof ctrl !== "undefined") {
				for (var j = 0; j < ctrl.length; j++) {
					if (ctrl[j].opener.value === data) {
						for (var i = 0; i < ctrl[j].targets.length; i++) {
							this.items[ctrl[j].targets[i]].show = true;
							r = this.items[ctrl[j].targets[i]].reqs;
							// r += '|required';
							r = "".concat("required|", r);
							this.items[ctrl[j].targets[i]].reqs = r;
						}
					} else {
						for (var i = 0; i < ctrl[j].targets.length; i++) {
							this.items[ctrl[j].targets[i]].show = false;
							this.items[ctrl[j].targets[i]].data = "";
							r = this.items[ctrl[j].targets[i]].reqs;
							if (r.slice(0, 9) === "required|") {
								r = r.slice(9);
							}
							// if (r.slice(-9) === '|required') {
							//   r = r.slice(0, (r.length - 9));
							// }
							this.items[ctrl[j].targets[i]].reqs = r;
						}
					}
				}
			}
		}, // end radioTrig

		phoneFormatter(value){
			
			if(value.length == 10){
				var str1 = value.substr(0,3);
				var str2= value.substr(3,3);
				var str3 = value.substr(6,4);
				value = str1+"-"+str2+"-"+str3;
			}
			else if (value.length < 12){
				value = value.replaceAll("-","");
			}
			return value;
		} //end phoneFormatter

	} // end methods
	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

hr{
	padding-top: 1.1em;
	border: 0;
}

ul {
	padding: 0;
}

li {
	margin: 0 0 0 3em;
}

div.is-danger {
	margin-top: 0.2rem;
	color: #b3a369;
	font-size: 0.8rem;
}

input.is-danger,
select.is-danger {
	border: solid #b3a369 1px;
}

.card-body p {
	font-size: 0.8rem;
}

.debug {
	font-size: 0.7em;
	max-width: 30%;
	height: 100%;
	overflow-y: scroll;
	position: fixed;
	border-right: solid 8px #b3a369;
	padding: 1em;
	right: 0;
	top: 0;
	background: rgba(7, 29, 73, 0.6);
	color: white;
	text-align: left;
}

.help-text {
	font-size: 0.8em;
	font-style: oblique;
	color: #666;
}

.data-debug {
	color: #999;
	font-style: oblique;
}

.jumbotron {
	/* background-color: #071d49;
  color: #fff;  */
	margin-bottom: 30px;
	font-size: 0.9rem;
	color: #071d49;
  	text-align: center;
	padding: 20px;
}

.miners {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/VueForm.vue